import React, { FC, useCallback, useEffect, useMemo, useState } from "react"
import { observer } from "mobx-react-lite"
import {
  ActivityIndicator,
  Appearance,
  ImageStyle,
  Platform,
  RefreshControl,
  TextInput,
  TextStyle,
  TouchableOpacity,
  useWindowDimensions,
  ViewStyle,
  Text as ReactText
} from "react-native"
import {
  ActionsheetIosAware,
  AutoImage,
  Button,
  Checkbox,
  FlatList,
  Input,
  JalaIcon,
  JalaLoading,
  ListRenderItem,
  ListRenderItemInfo,
  ModalJalaLoading, OfflineMode,
  Screen,
  Text
} from "../../../../components"
// import { useStores } from "../../models"
import { color, nativeBaseTheme, typography } from "../../../../theme"
import { CompositeScreenProps, useFocusEffect, useIsFocused } from "@react-navigation/native"
import { Actionsheet, ScrollView, useDisclose, View } from "native-base"
import { translate, TxKeyPath } from "../../../../i18n"
import { navigate } from "../../../../navigators"
import { useStores } from "../../../../models"
import moment from "moment"
import { SafeAreaView } from "react-native-safe-area-context"
import Modal from "react-native-modal"
import { FarmStoreModel } from "../../../../models/app-store/farm-store/farm-store"
import _ from "lodash"
import { delay } from "../../../../utils/delay"
import JalaAnalytic from "../../../../utils/jala-analytic"

const ROOT: ViewStyle = {
  flex: 1,
}

const IMG_CONTAINER: TextStyle = {
  flex: 1,
  // marginBottom: 56,
  alignItems: "center",
  marginTop: 100
  // justifyContent: "center",
}

const EMPTY_TITLE_TEXT: TextStyle = {
  marginTop: 50
}

const EMPTY_IMAGE: ImageStyle = {
  height: 150
}

const SUBTITLE_EMPTY: TextStyle = {
  marginHorizontal: 65,
  marginTop: 8
}

const BUTTON: ViewStyle = {
  backgroundColor: color.primary,
  paddingHorizontal: 29,
  marginTop: 20,
  paddingVertical: 8
}

const ARROW: ViewStyle = {
  paddingHorizontal: 10
}

const DATE_PICKER: ViewStyle = {
  flexDirection: 'row',
  alignItems: 'center'
}

const HEADER_CONTAINER = (height): ViewStyle => ({
  justifyContent: "space-between",
  flexDirection: "row",
  alignItems: 'center',
  backgroundColor: color.primary,
  height: height
})

const HEADER: ViewStyle = {
  flexDirection: 'row',
  alignItems: 'center'
}

const BACK_BUTTON: ViewStyle = {
  marginLeft: 16,
  marginRight: 12
}

const TOP_BAR_CONTAINER: ViewStyle = {
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "row"
}

const TOP_BAR_SEARCH_BUTTON: ViewStyle = {
  marginRight: 16,
}

const SEARCH_HEADER: ViewStyle = {
  flexDirection: 'row',
  alignItems: 'center',
  flex: 1,
}

const TEXT_FIELD: ViewStyle = {
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
  marginVertical: 0,
  paddingVertical: 0,
  backgroundColor: 'green',
  minHeight: 35
}

const BTN_CANCEL: ViewStyle = {
  marginHorizontal: 16
}

const MODAL: ViewStyle = {
  margin: 0,
  width: '100%',
  height: '80%',
  justifyContent: 'flex-end',
  position: 'absolute',
  bottom: 0,
  flex: 1
}

const MODAL_STATUS: ViewStyle = {
  margin: 0,
  width: '90%',
  flex: 1,
  alignSelf: 'center',
  paddingBottom: 10
}

const MODAL_CONTENT: ViewStyle = {
  padding: 16
}

const MODAL_STATUS_CONTENT: ViewStyle = {
  backgroundColor: color.palette.white,
  borderRadius: 10,
  // flex: 1
}

const VALUEDATA_CONTAINER = (show): ViewStyle => ({
  marginBottom: show ? 18 : 20,
  paddingHorizontal: 12,
})

const ITEM_LEFT: ViewStyle = {
  width: '78%',
}

const HIDDEN_BUTTON: ViewStyle = {
  flexDirection: "row",
  alignItems: "center",
  flex: 1
}

const ITEM_RIGHT: ViewStyle = {
  width: '22%',
}

const ADDITIONAL: ViewStyle = {
  width: '8%'
}

const ITEM_CONTAINER: ViewStyle = {
  marginTop: 12,
  marginBottom: 8,
  marginHorizontal: 12,
  backgroundColor: color.palette.white,
  borderRadius: 10,
}

const ITEM_HEADER_CONTAINER: ViewStyle = {
  flexDirection: "row",
  padding: 12,
  alignItems: "center",
  justifyContent: "space-between"
}

const ITEM_STATUS = (background): ViewStyle => ({
  borderRadius: 40,
  paddingHorizontal: 12,
  paddingVertical: 2,
  backgroundColor: background,
  alignItems: "center",
  justifyContent: "center"
})

const BORDER: ViewStyle = {
  backgroundColor: color.palette.gray200,
  height: 1,
  // marginBottom: 12
}

const OTHERS_BUTTON: ViewStyle = {
  paddingLeft: 12,
  marginBottom: 8
}

const CHANGE_STATUS_CONTAINER: ViewStyle = {
  flexDirection: 'row',
  paddingHorizontal: 10,
  paddingTop: 8,
  paddingBottom: 12,
  alignItems: 'center'
}

const CHANGE_IMAGE: ImageStyle = {
  width: 20,
  height: 20,
  resizeMode: 'contain'
}

const BOTTOM_BUTTON: ViewStyle = {
  // marginVertical: ,
  // marginTop: -10,
  marginHorizontal: 24,
  backgroundColor: color.primary,
  borderRadius: 4,
  height: 40,
  alignItems: 'center',
  flexDirection: 'row',
  justifyContent: 'center'
}

const SETTING_IMAGE: ImageStyle = {
  width: 24,
  height: 24,
  resizeMode: 'contain',
  marginRight: 8
}

const CHECKBOX: ViewStyle = {
  alignItems: 'center'
}

const BUTTON_MODAL = (disabled): ViewStyle => ({
  margin: 12,
  // paddingHorizontal: 60,
  paddingVertical: 8,
  backgroundColor: disabled ? color.palette.gray600 :  color.palette.blueJalaBase
})

const DATE_HEADER: ViewStyle = {
  paddingHorizontal: 12,
  paddingVertical: 10,
  backgroundColor: color.palette.white,
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between"
}

const DATE_MODAL_CONTAINER: ViewStyle = {
  backgroundColor: color.palette.white,
  borderRadius: 10
}

const DATE_MODAL_HEADER: ViewStyle = {
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  paddingHorizontal: 16,
  paddingVertical: 12
}

const DATE_MODAL_ITEM: ViewStyle = {
  borderBottomWidth: 1,
  borderBottomColor: color.palette.gray300,
  paddingHorizontal: 16,
  paddingTop: 12,
  paddingBottom: 32
}

const BUTTON_BACK_MODAL: ViewStyle = {
  borderRadius: 4,
  paddingVertical: 10,
  marginTop: 24
}

const INFO_DESCRIPTION = (isShow): ViewStyle => ({
  width: 25,
  marginRight: 13,
  paddingTop: isShow ? 3 : 1,
  justifyContent: "center",
  alignItems: "center"
})

const UNDERLINE_CONTAINER: ViewStyle = {
  alignSelf: 'flex-start',
  borderBottomWidth: 1,
  borderBottomColor: color.palette.blueJalaBase
}

const UNDERLINE_TEXT: TextStyle = {
  fontFamily: typography.primary,
  fontSize: 14,
  fontWeight: "700",
  lineHeight: 20,
  letterSpacing: 0.5,
  color: color.palette.blueJalaBase
}

const BOTTOM_BUTTON_CONTAINER: ViewStyle = {
  borderTopWidth: 1,
  borderTopColor: color.palette.gray300,
  paddingTop: 10,
  backgroundColor: color.palette.white,
}

const emptyPond = require("./empty-pond.png")
const emptyFarm = require("./empty-farm.png")
const change = require("./sync.png")
const setting = require("./setting.png")
const emptySearch = require("./empty-search.png")
const iconSync = require("./sync_gray.png")
const iconSetting = require("./setting_gray.png")

export const ActivityHeader: FC<CompositeScreenProps<any, any>> = observer(function ActivityHeader(props) {
  const { navigation, route } = props;
  const { cycleToDoStore } = useStores();

  const backIcon = Platform.OS === "ios" ? 'arrow_back_ios' : 'arrow_back';
  const colorScheme = "light"
  const inputRef = React.useRef<TextInput>()
  const isFocused = useIsFocused()

  const data = route && route.params && route.params.data || []
  const headerHeight = 55.8;
  const [ hidden, setHide ] = useState<boolean>(true);
  const handleChangeText = _.throttle((text) => {
    navigation.setParams({ data: { ...data, text } });
    JalaAnalytic.log('Mobile App: Activity - Search', { search: text })
  }, 500);
  const handleCancel = () => {
    setHide(!hidden);
    navigation.setParams({ data: { ...data, text: "" } })
  }

  return (<View backgroundColor={color.primary}>
    <SafeAreaView edges={["top"]} />
    {isFocused && <View style={HEADER_CONTAINER(headerHeight)}>
      {hidden ? (
        <>
          <View style={HEADER}>
            <Button testID="jala:id/back-button" preset="link" textPreset="display1" style={BACK_BUTTON}
                    colorScheme={colorScheme} onPress={navigation.goBack}>
              <JalaIcon name={backIcon} size={25} color={color.palette.white} />
            </Button>
            <Text tx="cycleToDoScreen.title" preset="title2" color={color.palette.white} />
          </View>
          <View style={TOP_BAR_CONTAINER}>
            <ModalInfo>
              <JalaIcon name="info-1" size={24} color={color.palette.white} style={TOP_BAR_SEARCH_BUTTON} />
            </ModalInfo>
            <Button testID="jala:id/refresh-button" preset="link" colorScheme="light" style={TOP_BAR_SEARCH_BUTTON} onPress={cycleToDoStore.onRefresh}>
              <JalaIcon name="refresh" size={24} color={color.palette.white} />
            </Button>
            <Button testID="jala:id/search-button" preset="link" colorScheme="light" style={TOP_BAR_SEARCH_BUTTON} onPress={() => setHide(!hidden)}>
              <JalaIcon name="search" size={24} color={color.palette.white} />
            </Button>
          </View>
        </>
      ) : (
        <View style={SEARCH_HEADER}>
          <Input ref={inputRef} style={TEXT_FIELD} placeholderTx="searchPondPlaceholder" borderRadius="40px" px="12px"
                 ml="16px" backgroundColor={color.palette.white} onChangeText={handleChangeText} />
          <Button testID="jala:id/cancel-button" preset="link" textPreset="title3" textColor={color.palette.white}
                  style={BTN_CANCEL} onPress={handleCancel} tx="cancel" colorScheme="light" />
        </View>
      )}
    </View>}
  </View>)
})

const Header: FC<{ colorScheme?: "light"|"dark" }> = observer(function Header() {
  const { appStore: { farmStore } } = useStores();
  const { farm } = farmStore || FarmStoreModel.create()

  return <View
    height="68px"
    paddingX="16px"
    paddingY="8px"
    marginBottom="4px"
    backgroundColor={color.palette.white}
  >
    <View height="24px" paddingY="2px" marginBottom="4px">
      <Text tx="farmForm.name" preset="title4" color={color.palette.gray800} />
    </View>
    <Text text={farm?.name || '-'} preset="title3" color={color.palette.gray800} numberOfLines={1} isTruncated />
  </View>
})

const DateHeader: FC<{ colorScheme?: "light"|"dark", date?: any, onPrevious?: () => void, onNext?: () => void, onPressDate?: () => void, disabled?: boolean }> = observer(function DateHeader(props) {
  const { onPrevious, onNext, date, onPressDate, disabled } = props;

  const disabledButton = moment(date).endOf('day').isAfter()
  const labelColor = disabled ? color.palette.gray600 : color.palette.gray800

  return (
    <View
      height="40px"
      paddingX="20px"
      paddingY="10px"
      backgroundColor={color.palette.white}
      borderBottomWidth="1px"
      borderBottomColor={color.background}
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
    >
      <TouchableOpacity style={ARROW} onPress={onPrevious} disabled={disabled}>
        <JalaIcon name="chevron_left" size={24} color={labelColor} />
      </TouchableOpacity>
      <TouchableOpacity style={DATE_PICKER} onPress={onPressDate} disabled={disabled}>
        <Text text={moment(date).format("DD MMMM YYYY")} color={labelColor} preset="body2" />
        <JalaIcon name="arrow_drop_down" size={20} color={labelColor} />
      </TouchableOpacity>
      <TouchableOpacity style={ARROW} onPress={onNext} disabled={disabledButton}>
        <JalaIcon name="chevron_right" size={24} color={disabledButton ? color.palette.gray600 : color.palette.gray800} />
      </TouchableOpacity>
    </View>
  )
})

const EmptyState: FC<{ colorScheme?: "light"|"dark", screen?: string, subtitle?: string, height?: string }> = observer(function EmptyList(props) {
  const { colorScheme, screen, ...restProps } = props

  const content = {
    farm: { title: 'cycleToDoScreen.empty', subtitle: 'cycleToDoScreen.emptyFarm', testID: 'jala:id/create-farm', button: 'pondScreen.addFarm' as TxKeyPath, img: emptyFarm },
    pond: { title: 'cycleToDoScreen.empty', subtitle: 'cycleToDoScreen.emptyPond', testID: 'jala:id/create-pond', button: 'pondScreen.addPond' as TxKeyPath, img: emptyPond },
    cycle: { title: 'cycleToDoScreen.empty', subtitle: 'cycleToDoScreen.emptyCycle', testID: 'jala:id/create-cycle', button: 'pondScreen.startCycle' as TxKeyPath, img: emptyPond },
    cycleNoButton: { title: 'cycleToDoScreen.empty', subtitle: 'cycleToDoScreen.emptyCycle', img: emptyPond },
    emptySearch: { title: 'cycleToDoScreen.emptySearchTitle', subtitle: 'cycleToDoScreen.emptySearchSubtitle', img: emptySearch }
  }

  const onNavigate = useCallback(() => {
    switch (screen) {
      case 'farm':
        navigate('Home.Stack', 'Home.Farm.Create', { route: 'create' }); break;
      case 'pond':
        navigate('Home.Stack', 'Home.Pond.PreCreateMultiple'); break;
      case 'cycle':
        navigate('Home.Stack', 'Home.Cycle.CreateMultiple'); break;
    }
  }, [screen])

  return (
    <View {...restProps} style={IMG_CONTAINER}>
      <>
        <AutoImage source={content[screen].img} resizeMode="contain" style={EMPTY_IMAGE} />
        {content[screen].subtitle && <Text
          preset="title3"
          text={translate(content[screen].title as TxKeyPath)}
          style={EMPTY_TITLE_TEXT}
          color={color.palette.gray800}
        />}
        {content[screen].subtitle && <Text
          preset="body2"
          text={translate(content[screen].subtitle)}
          color={color.palette.gray800}
          style={SUBTITLE_EMPTY}
          textAlign="center"
        />}
        {!!content[screen].button && <Button
          testID={content[screen].testID}
          text={translate(content[screen].button)}
          textPreset="title5"
          textColor={color.palette.white}
          colorScheme={colorScheme}
          onPress={onNavigate}
          style={BUTTON}
        />}
      </>
    </View>
  )
})

const ModalInfo: FC<{ colorScheme?: "light" | "dark" }> = observer(function ModalInfo(props) {
  const { colorScheme = "light" || Appearance.getColorScheme(), children } = props;
  const { isOpen, onClose, onOpen } = useDisclose()

  const descriptionList = [
    { icon: 'info-1', iconSize: 18, iconColor: color.palette.gray800, label: "cycleToDoScreen.infoDescription"  },
    { icon: 'refresh', iconSize: 18, iconColor: color.palette.gray800, label: "cycleToDoScreen.refreshDescription"  },
    { icon: 'search', iconSize: 18, iconColor: color.palette.gray800, label: "cycleToDoScreen.searchDescription"  },
    { icon: 'check_round', iconSize: 12, iconColor: color.palette.gray400, background: color.palette.gray200, label: "cycleToDoScreen.incompleteDescription"  },
    { icon: 'check_round', iconSize: 12, iconColor: color.palette.green600, background: color.palette.green300, label: "cycleToDoScreen.completeDescription"  },
    { icon: 'show', iconSize: 12, iconColor: color.palette.gray800, label: "cycleToDoScreen.hiddenDescription"  },
    { icon: null, iconSize: 20, image: iconSync, iconColor: color.palette.gray800, label: "cycleToDoScreen.changeStatusDescription"  },
    { icon: null, iconSize: 20, image: iconSetting, iconColor: color.palette.gray800, label: "cycleToDoScreen.settingDescription"  }
  ]

  const renderItem: ListRenderItem<any> = useCallback((info) => {
    const { item } = info
    return (
      <View flexDirection="row" alignItems="flex-start" marginTop="12px">
        <View style={INFO_DESCRIPTION(item.icon && item.icon === 'show')}>
          {item.icon
            ? item.icon === 'check_round'
              ? <View alignItems="center" justifyContent="center" padding="2px" borderRadius={50} backgroundColor={item.background} borderWidth={1} borderColor={item.iconColor}>
                  <JalaIcon name={item.icon} size={item.iconSize} color={item.iconColor} />
                </View>
              : <JalaIcon name={item.icon} size={item.iconSize} color={item.iconColor} />
            : <AutoImage source={item.image} style={CHANGE_IMAGE} />
          }
        </View>
        <View flex={1} justifyContent="center">
          <Text text={translate(item.label as TxKeyPath)} preset="body2" color={color.palette.gray800}/>
        </View>
      </View>
    )
  }, [])

  return (<>
    <TouchableOpacity onPress={onOpen}>
      {children}
    </TouchableOpacity>
    <ActionsheetIosAware isOpen={isOpen} onClose={onClose}>
      <Actionsheet.Content alignItems="stretch" px={0} py={0}>
        <ScrollView
          showsVerticalScrollIndicator={false}
          style={MODAL_CONTENT}
          backgroundColor={colorScheme === 'light' ? nativeBaseTheme.colors.light["50"] : nativeBaseTheme.colors.dark["50"]}
        >
          <Text tx="cycleToDoScreen.infoTitle" preset="title3" color={color.palette.gray800} alignSelf="center" />
          <Text tx="cycleToDoScreen.info" preset="body2" color={color.palette.gray800} marginTop="13px" />
          <Text tx="cycleToDoScreen.functionDescription" preset="title4" color={color.palette.gray800} marginTop="24px" />
          <FlatList data={descriptionList} renderItem={renderItem} />
          <Button
            testID="jala:id/back-button"
            tx="common.back"
            colorScheme={colorScheme}
            style={BUTTON_BACK_MODAL}
            onPress={onClose}
          />
        </ScrollView>
      </Actionsheet.Content>
    </ActionsheetIosAware>
  </>)
})

const ValueData: FC<{
  colorScheme?: "light"|"dark",
  onPressLeft?: () => void,
  isShow?: boolean,
  canExpand?: boolean,
  isCheck?: boolean,
  canHide?: boolean,
  paramName?: string,
  title?: string,
  pondId?: number,
  date?: any,
  cycle: any
}> = observer(function ValueData(props) {
  const { colorScheme, onPressLeft, isShow, canExpand, isCheck, canHide, paramName, title, date, cycle } = props
  const { appStore: { farmStore }, cycleToDoStore } = useStores();

  const [ loading, setLoading ] = useState<boolean>(false)

  const setHide = useCallback((parameter) => () => {
    let body: any
    if (!cycle) return;
    if ( cycle.cycle_to_do ) {
      body = { cycle_to_dos: [{
          id: cycle.cycle_to_do.id,
          cycle_id: cycle.id,
          logged_at: date,
          state: { [parameter]: isCheck ? null : 'skip' }
        }] }
    } else {
      body = { cycle_to_dos: [{
          cycle_id: cycle.id,
          logged_at: date,
          state: { [parameter]: 'skip' }
        }]}
    }
    setLoading(true);
    cycleToDoStore.updateFarm(body)
      .finally(() => {
        farmStore.getCycleToDos(true, () => {
          setLoading(false)
        })
      })
  }, [cycle, cycleToDoStore, date, isCheck, farmStore])

  const isActive = canExpand ? isCheck : (cycle?.cycle_to_do?.state || {})[paramName];
  const iconDrop = isShow ? "arrow_drop_up" : "arrow_drop_down"
  const iconColor = isActive && isActive !== 'skip' ? color.palette.green600 : color.palette.gray400
  const iconBackground = isActive ? color.palette.green300 : color.palette.gray200
  const iconHide = isActive === 'skip' ? "hide" : "show"
  const textDecoration = isActive === 'skip' ? "line-through" : "none"

  return (
    <View style={VALUEDATA_CONTAINER(isShow)}>
      <View flexDirection="row" alignItems="center">
        <TouchableOpacity style={HIDDEN_BUTTON} onPress={onPressLeft} disabled={isActive === 'skip'}>
          <View style={ITEM_LEFT} flexDirection="row" alignItems="center">
            <JalaIcon name="kecerahan-1" size={7} color={color.palette.blueJalaBase} />
            <Text preset="body2" text={translate(title as TxKeyPath)} colorScheme={colorScheme} color={color.palette.blueJalaBase} marginX="5px" textDecorationLine={textDecoration} />
            {canExpand && <JalaIcon name={iconDrop} size={20} color={color.palette.blueJalaBase} />}
          </View>
          <View style={ITEM_RIGHT} alignItems="center">
            {!(isActive === 'skip') && <View alignItems="center" justifyContent="center" padding="4px" borderRadius={50} backgroundColor={iconBackground} borderWidth={1} borderColor={iconColor}>
              <JalaIcon name="check_round" size={17} color={iconColor} />
            </View>}
          </View>
        </TouchableOpacity>
        {canHide && !isActive ? <View style={ADDITIONAL} alignItems="center">
        <TouchableOpacity onPress={setHide(paramName)}>
          {loading ? <ActivityIndicator size={15} /> : <JalaIcon name={iconHide} size={15} color={color.primary} />}
        </TouchableOpacity>
      </View> : <View style={ADDITIONAL} />}
      </View>
    </View>
  )
})

const HiddenListItem: FC<{
  colorScheme?: "light"|"dark",
  isActive?: any,
  canHide?: boolean,
  title?: string,
  paramName?: string,
  onPressItem?: () => void,
  pondId?: number,
  date?: any,
  cycle?: any
}> = observer(function HiddenListItem(props) {
  const { isActive, canHide, title, onPressItem, paramName, date, cycle } = props
  const { appStore: { farmStore }, cycleToDoStore } = useStores();
  const [ loading, setLoading ] = useState<boolean>(false)

  const setHide = useCallback((parameter) => () => {
    let body: any
    if (!cycle) return;
    if ( cycle.cycle_to_do ) {
      body = { cycle_to_dos: [{
          id: cycle.cycle_to_do.id,
          cycle_id: cycle.id,
          logged_at: date,
          state: { [parameter]: isActive ? null : 'skip' }
        }] }
    } else {
      body = { cycle_to_dos: [{
          cycle_id: cycle.id,
          logged_at: date,
          state: { [parameter]: 'skip' }
        }]}
    }
    setLoading(true);
    cycleToDoStore.updateFarm(body)
      .finally(() => {
        farmStore.getCycleToDos(true, () => {
          setLoading(false)
        })
      })
  }, [cycle, cycleToDoStore, date, isActive, farmStore])

  const iconColor = isActive && isActive !== 'skip' ? color.palette.green600 : color.palette.gray400
  const iconHide = isActive === 'skip' ? "hide" : "show"
  const textDecoration = isActive === 'skip' ? "line-through" : "none"
  const fontColor = isActive === 'skip' ? color.palette.gray600 : color.palette.blueJalaBase

  return (
    <View flexDirection="row" alignItems="center" marginBottom="16px">
      <TouchableOpacity style={HIDDEN_BUTTON} onPress={onPressItem} disabled={isActive === 'skip'}>
        <View flex={1} style={ITEM_LEFT} paddingLeft="18px" flexDirection="row">
          <Text text="-" color={color.palette.blueJalaBase} preset="body2" marginRight="5px" />
          <Text text={title} color={fontColor} preset="body2" textDecorationLine={textDecoration} />
        </View>
        <View style={ITEM_RIGHT} alignItems="center">
          {!(isActive === 'skip') && <JalaIcon name="check_round" size={20} color={iconColor} />}
        </View>
      </TouchableOpacity>
      {canHide && (isActive === 'skip' || !isActive) ? <View style={ADDITIONAL} alignItems="center">
        <TouchableOpacity onPress={setHide(paramName)}>
          {loading ? <ActivityIndicator size={15} /> : <JalaIcon name={iconHide} size={15} color={color.primary} />}
        </TouchableOpacity>
      </View> : <View style={ADDITIONAL} />}
    </View>
  )
})

const FeedList: FC<{
  colorScheme?: "light"|"dark",
  cycle?: any,
  cycleToDo?: any,
  onPressItem?: (key?: string,
  state?: boolean) => () => void,
  pondId?: number,
  date?: any
}> = observer(function FeedList(props) {
  const { cycle, cycleToDo, onPressItem, pondId, date } = props

  const isActive = useCallback((key) => !_.isEmpty(cycleToDo) && cycleToDo.state[key], [cycleToDo])

  const renderItem: ListRenderItem<any> = useCallback((info) => {
    const key = `feed_${info.item}`
    return (
      <HiddenListItem
        paramName={key}
        title={`${translate("quickInput.feed")} ${info.item}`}
        isActive={isActive(key)}
        canHide={[4,5].includes(info.item)}
        onPressItem={onPressItem(key, isActive(key))}
        pondId={pondId}
        date={date}
        cycle={cycle}
      />
    )
  }, [isActive, onPressItem, pondId, date, cycle])

  return (
    <View paddingX="12px">
      <FlatList data={[1,2,3,4,5]} renderItem={renderItem} estimatedItemSize={36} />
    </View>
  )
})

const MeasurementList: FC<{
  colorScheme?: "light"|"dark",
  cycleToDo?: any,
  onPressItem?: (key?: string, state?: boolean) => () => void,
  pondId?: number
}> = observer(function MeasurementList(props) {
  const { cycleToDo, onPressItem, pondId } = props

  const isActive = useCallback((key) => !_.isEmpty(cycleToDo) && cycleToDo.state[key], [cycleToDo])
  // const isActive = useCallback((key) => cycleToDo.length && cycleToDo.find((item) => item.state[key]), [cycleToDo])

  return (
    <View paddingX="12px">
      <HiddenListItem
        paramName="water_quality_morning"
        title={translate("cycleToDoScreen.morningRecord")}
        isActive={isActive('water_quality_morning')}
        onPressItem={onPressItem('water_quality_morning', isActive('water_quality_morning'))}
        pondId={pondId}
        date={moment().format('YYYY-MM-DD')}
      />
      <HiddenListItem
        paramName="water_quality_evening"
        title={translate("cycleToDoScreen.eveningRecord")}
        isActive={isActive('water_quality_evening')}
        onPressItem={onPressItem('water_quality_evening', isActive('water_quality_evening'))}
        pondId={pondId}
        date={moment().format('YYYY-MM-DD')}
      />
    </View>
  )
})

const ActivityItem: FC<{ colorScheme?: "light"|"dark", info?: ListRenderItemInfo<any>, onChangeStatus?: () => void, age?: number, selectedDate?: any }> = observer(function ActivityItem(props) {
  const { info: { item }, onChangeStatus, selectedDate } = props
  const { appStore, appStore: { farmStore }, cycleToDoStore: { hiddenParameter }, cycleToDoStore, cycleToDoStore: { hiddenState } } = useStores();
  const { farm } = farmStore || FarmStoreModel.create();
  const feedGroup = (farm.state && farm.state.feed_group) ? farm.state.feed_group : []

  const [ showOther, setShowOther ] = useState<any>({})

  const setHiddenState = useCallback((parameter) => () => {
    cycleToDoStore.setHiddenState(parameter, item.id, selectedDate || moment().format('YYYY-MM-DD'))
  }, [cycleToDoStore, item.id, selectedDate])

  const isStateHidden = useCallback((parameter) => {
    const hiddenStatePond = hiddenState.find((obj) => obj.pondId === item.id && obj.date === selectedDate)
    return !!(hiddenStatePond && hiddenStatePond.parameter.includes(parameter))
  }, [hiddenState, selectedDate, item])

  const onNavigate = useCallback((key, state) => async () => {
    if (!item) return;
    if (appStore.farmStore) appStore.farmStore.set('pondId', item.pond_id)
    if (appStore.farmStore.pondStore) appStore.farmStore.pondStore.set('cycleId', item.id)
    await delay(1);

    switch (key) {
      case 'feeding_tray_control':
        if (state) navigate('Home.Stack', 'Home.Cycle.Stack', { screen: 'Home.Cycle.FeedingTrayControl.List' })
        else navigate('Home.Stack', 'Home.FeedingTrayControl.CreateMultiple', { cycle_id: item.id, logged_date: selectedDate })
        break;
      case 'sampling':
        if (state) navigate('Home.Stack', 'Home.Cycle.Stack', { screen: 'Home.Cycle.Sampling.List' })
        else navigate('Home.Stack', 'Home.Sampling.Create', { cycle_id: item.id, sampled_at: selectedDate })
        break;
      case 'mortality':
        if (state) navigate('Home.Stack', 'Home.Cycle.Stack', { screen: 'Home.Cycle.Mortality.List' })
        else navigate('Home.Stack', 'Home.Mortality.Create', { cycle_id: item.id, recorded_at: selectedDate })
        break;
      case 'harvest_partial':
      case 'harvest_total':
        if (state) navigate('Home.Stack', 'Home.Cycle.Stack', { screen: 'Home.Cycle.Harvest.List' })
        else navigate('Home.Stack', 'Home.Harvest.Create', { cycle_id: item.id, harvested_at: selectedDate })
        break;
      case 'feed_1':
        if (state) navigate('Home.Stack', 'Home.Cycle.Stack', { screen: 'Home.Cycle.Feed.List' })
        else navigate('Home.Stack', 'Home.Feed.Create', { cycle_id: item.id, logged_at: moment(`${selectedDate} ${feedGroup.length > 0 ? feedGroup[0].time : '07:00:00'}`).utc().format('YYYY-MM-DD HH:mm:ss') })
        break;
      case 'feed_2':
        if (state) navigate('Home.Stack', 'Home.Cycle.Stack', { screen: 'Home.Cycle.Feed.List' })
        else navigate('Home.Stack', 'Home.Feed.Create', { cycle_id: item.id, logged_at: moment(`${selectedDate} ${feedGroup.length > 1 ? feedGroup[1].time : '10:30:00'}`).utc().format('YYYY-MM-DD HH:mm:ss') })
        break;
      case 'feed_3':
        if (state) navigate('Home.Stack', 'Home.Cycle.Stack', { screen: 'Home.Cycle.Feed.List' })
        else navigate('Home.Stack', 'Home.Feed.Create', { cycle_id: item.id, logged_at: moment(`${selectedDate} ${feedGroup.length > 2 ? feedGroup[2].time : '12:30:00'}`).utc().format('YYYY-MM-DD HH:mm:ss') })
        break;
      case 'feed_4':
        if (state) navigate('Home.Stack', 'Home.Cycle.Stack', { screen: 'Home.Cycle.Feed.List' })
        else navigate('Home.Stack', 'Home.Feed.Create', { cycle_id: item.id, logged_at: moment(`${selectedDate} ${feedGroup.length > 3 ? feedGroup[3].time : '18:30:00'}`).utc().format('YYYY-MM-DD HH:mm:ss') })
        break;
      case 'feed_5':
        if (state) navigate('Home.Stack', 'Home.Cycle.Stack', { screen: 'Home.Cycle.Feed.List' })
        else navigate('Home.Stack', 'Home.Feed.Create', { cycle_id: item.id, logged_at: moment(`${selectedDate} ${feedGroup.length > 4 ? feedGroup[4].time : '21:30:00'}`).utc().format('YYYY-MM-DD HH:mm:ss') })
        break;
      case 'water_quality_morning':
        if (state) navigate('Home.Stack', 'Home.Cycle.Stack', { screen: 'Home.Cycle.WaterQualityMultiMeasurement.List' })
        else navigate('Home.Stack', 'Home.WaterQualityMultiMeasurement.Create', { pond_id: item.pond_id, cycle_id: item.id, measured_date: selectedDate, measured_time: '07:00:00' })
        break;
      case 'water_quality_evening':
        if (state) navigate('Home.Stack', 'Home.Cycle.Stack', { screen: 'Home.Cycle.WaterQualityMultiMeasurement.List' })
        else navigate('Home.Stack', 'Home.WaterQualityMultiMeasurement.Create', { pond_id: item.pond_id, cycle_id: item.id, measured_date: selectedDate, measured_time: '17:00:00' })
        break;
      case 'treatment':
        if (state) navigate('Home.Stack', 'Home.Cycle.Stack', { screen: 'Home.Cycle.Treatment.List' })
        else navigate('Home.Stack', 'Home.Treatment.Create', { pond_id: item.pond_id, cycle_id: item.id, treated_at: selectedDate })
        break;
    }
  }, [appStore.farmStore, item, selectedDate])

  const isDone = useCallback((keys) => {
    const cycleToDo = item.cycle_to_do || {}
    const hiddenParameterFiltered = hiddenParameter.filter((pond) => pond.pondId === item.id && pond.date === selectedDate)
    const filteredKey = hiddenParameterFiltered.length ? keys.filter(value => !hiddenParameterFiltered[0].parameter.includes(value)) : keys
    return cycleToDo && cycleToDo.state && filteredKey.every((key) => cycleToDo.state[key])
  }, [hiddenParameter, item, selectedDate])

  const additionalParameterData = useCallback(() => {
    if (farm.state && farm.state.cycle_to_do) {
      return (farm.state.cycle_to_do || []).filter((i) => parseInt(i.from) <= item.ageAtDate && parseInt(i.to) >= item.ageAtDate)
    }
    else return []
  }, [item, farm])

  const cycleToDosStatus = useCallback(() => {
    const cycleToDo = item.cycle_to_do
    let status = {
      label: translate('cycleToDoScreen.complete'),
      labelColor: color.palette.green600,
      background: color.palette.green300
    }
    const mainKey = ['feed_1', 'feed_2', 'feed_3', 'feed_4', 'feed_5', 'water_quality_morning', 'water_quality_evening', 'treatment']
    const additionalKey = additionalParameterData()
    const additionalParameter = additionalKey.length ? additionalKey.map((param) => param.key ) : []
    const allKey = [...mainKey, ...additionalParameter]
    const hiddenParameterFiltered = hiddenParameter.filter((pond) => pond.pondId === item.id && pond.date === selectedDate)
    const filteredKey = hiddenParameterFiltered.length ? allKey.filter(value => !hiddenParameterFiltered[0].parameter.includes(value)) : allKey
    const isMainComplete = cycleToDo && cycleToDo.state && filteredKey.every((key) => cycleToDo.state[key])
    const isNow = selectedDate === moment().format('YYYY-MM-DD')
    if(!isMainComplete && !isNow) {
      status = {
        label: translate('cycleToDoScreen.missed'),
        labelColor: color.palette.red600,
        background: color.palette.red300
      }
    }
    else if (!isMainComplete) {
      status = {
        label: translate('cycleToDoScreen.incomplete'),
        labelColor: color.palette.blue500,
        background: color.palette.ocean200
      }
    }
    return status
  }, [additionalParameterData, hiddenParameter, item, selectedDate])

  const showingOtherParams = useCallback(() => {
    const isExist = !_.isEmpty(showOther) && showOther.date === selectedDate ? showOther : {}
    return !_.isEmpty(isExist) ? isExist.status : false
  }, [selectedDate, showOther])

  const renderItem: ListRenderItem<any> = useCallback((info) => {
    const { item: { key } } = info
    return (
      <ValueData
        paramName={key}
        title={`cycleToDoScreen.${key}`}
        onPressLeft={onNavigate(key, isDone([key]))}
        isCheck={isDone([key])}
        canHide
        pondId={item.id}
        date={selectedDate}
        cycle={item}
      />
    )
  }, [onNavigate, isDone, item, selectedDate])

  const textOtherButton = showingOtherParams() ? "cycleToDoScreen.seeLess" : "cycleToDoScreen.seeOthers"
  const ageColorText = item.ageAtDate< 0 ? color.palette.red600 : color.palette.gray700
  const cycleToDoStatus = cycleToDosStatus()

  if (!item) return null;
  return (
    <View style={ITEM_CONTAINER}>
      <View style={ITEM_HEADER_CONTAINER}>
        <View maxWidth="60%">
          <Text numberOfLines={1} text={item.pond?.name || '-'} preset="title3" color={color.palette.gray800} />
          <Text text={`DoC: ${item.ageAtDate}`} preset="body3" color={ageColorText} />
        </View>
        <View style={ITEM_STATUS(cycleToDoStatus.background)}>
          <Text text={cycleToDoStatus.label} preset="body3" color={cycleToDoStatus.labelColor} />
        </View>
      </View>
      <View style={BORDER} />
      <View marginBottom="12px" />
      <ValueData
        paramName="feed"
        title="cycleToDoScreen.feeding"
        canExpand
        onPressLeft={setHiddenState('Feed')}
        isShow={isStateHidden('Feed')}
        isCheck={isDone(['feed_1', 'feed_2', 'feed_3', 'feed_4', 'feed_5'])}
        pondId={item.id}
        cycle={item}
      />
      {isStateHidden('Feed') && <FeedList cycle={item} cycleToDo={item.cycle_to_do || {}} onPressItem={onNavigate} pondId={item.id} date={selectedDate} />}
      <ValueData
        paramName="measurement"
        title="cycleToDoScreen.measuring"
        canExpand
        onPressLeft={setHiddenState('Measurement')}
        isShow={isStateHidden('Measurement')}
        isCheck={isDone(['water_quality_morning', 'water_quality_evening'])}
        pondId={item.id}
        cycle={item}
      />
      {isStateHidden('Measurement') && <MeasurementList cycleToDo={item.cycle_to_do || {}} onPressItem={onNavigate} pondId={item.id} />}
      {showingOtherParams() && <ValueData
        paramName={'treatment'}
        title="cycleToDoScreen.treatment"
        isCheck={isDone(['treatment'])}
        onPressLeft={onNavigate('treatment', isDone(['treatment']))}
        pondId={item.id}
        cycle={item}
      />}
      {showingOtherParams() && <FlatList
        data={additionalParameterData()}
        renderItem={renderItem}
      />}
      <TouchableOpacity style={OTHERS_BUTTON} onPress={() => setShowOther({ date: selectedDate, status: !showingOtherParams()})}>
        <View>
          <View style={UNDERLINE_CONTAINER}>
            <ReactText style={UNDERLINE_TEXT}>{translate(textOtherButton)}</ReactText>
          </View>
        </View>
      </TouchableOpacity>
      <View style={BORDER} />
      <TouchableOpacity style={CHANGE_STATUS_CONTAINER} onPress={onChangeStatus}>
        <AutoImage source={change} style={CHANGE_IMAGE} />
        <Text tx="cycleToDoScreen.changeActivityStatus" preset="title4" color={color.palette.blueJalaBase} marginLeft="5px" />
      </TouchableOpacity>
    </View>
  )
})

const CheckboxStatus: FC<{ colorScheme?: "light"|"dark", value?: any, onCheck?: () => void, title?: string, statusKey?: string }> = observer(function CheckboxStatus(props) {
  const { colorScheme, value, onCheck, title, statusKey } = props
  const [ isChecked, setIsChecked ] = useState<boolean>(false)
  useEffect(() => {
    if(!_.isEmpty(value)) {
      const isExist = value[statusKey] && !!value[statusKey]
      setIsChecked(isExist)
    } else setIsChecked(false)
  }, [value, statusKey])

  return (
    <Checkbox
      value={isChecked}
      onToggle={onCheck}
      text={title}
      colorScheme={colorScheme}
      labelPreset="body3"
      labelStyle={{ color: color.palette.gray800 }}
      outlineStyle={{ borderColor: color.palette.gray800 }}
      style={CHECKBOX}
    />
  )
})

const ModalChangeStatus: FC<{ colorScheme?: "light"|"dark", isOpen?: boolean, onClose?: () => void, cycle?: any, date?: any }> = observer(function ModalChangeStatus(props) {
  const { isOpen, onClose, cycle, colorScheme, date } = props
  const { cycleToDoStore, appStore: { farmStore } } = useStores();
  const { farm } = farmStore || FarmStoreModel.create()
  const [ activeStatus, setActiveStatus ] = useState<any>({})

  useEffect(() => {
    const cycleToDo = cycle.cycle_to_do && cycle.cycle_to_do.logged_at === date ? cycle.cycle_to_do : {}
    const state = !_.isEmpty(cycleToDo) ? cycleToDo.state : {}
    setActiveStatus(state)
  }, [date, cycle])

  const doc = useCallback(() => {
    return cycle.ageAtDate;
  }, [cycle.ageAtDate])

  const isStateActive = (dataFrom, dataTo) => {
    const to = parseInt(dataTo)
    const from = parseInt(dataFrom)
    return doc() >= from && doc() <= to
  }

  const onCheck = useCallback((key) => () => {
    return activeStatus[key] && !!activeStatus[key]
      ? setActiveStatus({...activeStatus, [key]: null})
      : setActiveStatus({...activeStatus, [key]: 'done'})
  }, [activeStatus])

  const onSave = useCallback(() => {
    let body: any
    if ( cycle.cycle_to_do ) {
      body = { cycle_to_dos: [{
        id: cycle.cycle_to_do.id,
        cycle_id: cycle.id,
        logged_at: date,
        state: activeStatus
      }] }
    } else {
      body = { cycle_to_dos: [{
        cycle_id: cycle.id,
        logged_at: date,
        state: activeStatus
      }]}
    }
    cycleToDoStore.updateFarm(body)
      .finally(() => {
        onClose()
        farmStore.getCycleToDos()
      })
  }, [cycle, cycleToDoStore, date, activeStatus, onClose, farmStore])

  return (
    <Modal
      isVisible={isOpen}
      style={MODAL_STATUS}
      onBackdropPress={onClose}
      backdropTransitionOutTiming={0}
      backdropColor={color.primary}
      animationIn="slideInUp"
      animationOut="slideOutDown"
      animationInTiming={300}
      animationOutTiming={300}
      backdropTransitionInTiming={600}
    >
      <SafeAreaView />
      <View style={MODAL_STATUS_CONTENT}>
        <View flexDirection="row" padding="12px" alignItems="center" justifyContent="space-between">
          <Text tx="cycleToDoScreen.changeActivityStatus" preset="title3" color={color.palette.gray800} />
          <TouchableOpacity onPress={onClose}>
            <JalaIcon name="close" size={20} color={color.palette.gray800} />
          </TouchableOpacity>
        </View>
        <View style={BORDER} />
        <View paddingX="12px" marginTop="8px">
          <Text text={cycle.pond?.name || '-'} preset="title4" color={color.palette.gray800} />
          <Text tx="cycleToDoScreen.feeding" preset="body3" color={color.palette.gray800} marginTop="14px" />
          <CheckboxStatus title={`${translate("quickInput.feed")} 1`} onCheck={onCheck('feed_1')} value={activeStatus} statusKey="feed_1" />
          <CheckboxStatus title={`${translate("quickInput.feed")} 2`} onCheck={onCheck('feed_2')} value={activeStatus} statusKey="feed_2" />
          <CheckboxStatus title={`${translate("quickInput.feed")} 3`} onCheck={onCheck('feed_3')} value={activeStatus} statusKey="feed_3" />
          <CheckboxStatus title={`${translate("quickInput.feed")} 4`} onCheck={onCheck('feed_4')} value={activeStatus} statusKey="feed_4" />
          <CheckboxStatus title={`${translate("quickInput.feed")} 5`}  onCheck={onCheck('feed_5')} value={activeStatus} statusKey="feed_5" />
          <Text tx="cycleToDoScreen.measuring" preset="body3" color={color.palette.gray800} marginTop="18px" />
          <CheckboxStatus title={translate("cycleToDoScreen.morningRecord")} onCheck={onCheck('water_quality_morning')} value={activeStatus} statusKey="water_quality_morning" />
          <CheckboxStatus title={translate("cycleToDoScreen.eveningRecord")} onCheck={onCheck('water_quality_evening')} value={activeStatus} statusKey="water_quality_evening" />
          <View marginTop="10px" />
          <CheckboxStatus title={translate("cycleToDoScreen.treatment")} onCheck={onCheck('treatment')} value={activeStatus} statusKey="treatment" />
          {farm && farm.state && farm.state.cycle_to_do && farm.state.cycle_to_do.map((item) => isStateActive(item.from, item.to) && (
            <CheckboxStatus
              key={item.key}
              title={translate(`cycleToDoScreen.${item.key}` as TxKeyPath)}
              onCheck={onCheck(item.key)}
              value={activeStatus}
              statusKey={item.key}
            />
          ))}
        </View>
        <View borderTopWidth="1px" borderTopColor="gray.300" marginTop="5px">
          <Button
            testID="jala:id/activiti-change-status-button"
            text={translate("cycleToDoScreen.changeStatus")}
            colorScheme={colorScheme}
            onPress={onSave}
            style={BUTTON_MODAL(_.isEmpty(activeStatus))}
            disabled={_.isEmpty(activeStatus)}
            textColor={color.palette.white}
          />
        </View>
      </View>
    </Modal>
  )
})

const DateModalItem: FC<{ colorScheme?: "light"|"dark", info?: any, onPress?: () => void }> = observer(function DateModalItem(props) {
  const { info, onPress } = props
  const { item } = info
  const { appStore: { farmStore }, cycleToDoStore: { hiddenParameter } } = useStores();
  const { farm } = farmStore || FarmStoreModel.create({})

  const additionalParameterData = useCallback((cycle) => {
    if (farm.state && farm.state.cycle_to_do) {
      return (farm.state.cycle_to_do || []).filter((i) => parseInt(i.from) <= cycle.ageAtDate && parseInt(i.to) >= cycle.ageAtDate)
    }
    else return []
  }, [farm])

  const cycleStatus = useCallback((cycle) => {
    const mainKey = ['feed_1', 'feed_2', 'feed_3', 'feed_4', 'feed_5', 'water_quality_morning', 'water_quality_evening', 'treatment']
    const additionalKey = additionalParameterData(cycle)
    const additionalParameter = additionalKey.length ? additionalKey.map((param) => param.key ) : []
    const allKey = [...mainKey, ...additionalParameter]
    const hiddenParameterFiltered = hiddenParameter.filter((pond) => pond.date === item.logged_at)
    const filteredKey = hiddenParameterFiltered.length ? allKey.filter(value => !hiddenParameterFiltered[0].parameter.includes(value)) : allKey
    const isMainComplete = cycle.cycle_to_do && cycle.cycle_to_do.state && filteredKey.every((key) => cycle.cycle_to_do.state[key])
    return !!isMainComplete
  }, [additionalParameterData, hiddenParameter, item])

  const cyclesStatus = useCallback(() => {
    const status = item.cycles.length !== 0 ? item.cycles.map((cycle) => cycleStatus(cycle)) : []
    const isDateStatusComplete = status.length === 0 ? false : status.every((key) => key === true)
    const isNow = item.logged_at === moment().format('YYYY-MM-DD')
    let dateStatus = {
      label: translate('cycleToDoScreen.complete'),
      labelColor: color.palette.green600,
      background: color.palette.green300
    }
    if(!isDateStatusComplete && !isNow) {
      dateStatus = {
        label: translate('cycleToDoScreen.missed'),
        labelColor: color.palette.red600,
        background: color.palette.red300
      }
    }
    else if (!isDateStatusComplete) {
      dateStatus = {
        label: translate('cycleToDoScreen.incomplete'),
        labelColor: color.palette.blue500,
        background: color.palette.ocean200
      }
    }
    return dateStatus
  }, [cycleStatus, item])

  // eslint-disable-next-line camelcase
  const date = item.logged_at
  const status = cyclesStatus()
  const emptyCycles = _.isEmpty(item) || item.cycles.length === 0

  return (
    <TouchableOpacity style={DATE_MODAL_ITEM} onPress={onPress}>
      <View flexDirection="row" alignItems="center" justifyContent="space-between">
        <Text text={moment(date).format('DD MMMM YYYY')} preset="title4" color={color.palette.gray800} />
        {!emptyCycles && <View paddingX="12px" paddingY="2px" justifyContent="center" alignItems="center" borderRadius="30px" backgroundColor={status.background}>
          <Text text={status.label} preset="body3" color={status.labelColor} />
        </View>}
      </View>
      {/* <Text preset="body2" color={color.palette.gray700} text="Siklus ditutup" /> */}
    </TouchableOpacity>
  )
})

const ModalDate: FC<{ colorScheme?: "light"|"dark", isOpen?: boolean, onClose?: () => void, date?: any, activity?: any, onPressDateItem?: (item?: any) => () => void }> = observer(function ModalDate(props) {
  const { isOpen, onClose, onPressDateItem, date } = props
  const { appStore: { farmStore } } = useStores();
  const {
    pondStoreModels,
    lastUpdatePond, lastUpdateCycle, lastUpdateCycleToDo,
  } = farmStore || FarmStoreModel.create({})
  const [ modalDate, setModalDate ] = useState<string>(moment(date).format('YYYY-MM-DD'))
  const [ dateList, setDateList ] = useState<Array<any>>([])
  const [ loading, setLoading ] = useState<boolean>(false)

  const disabled = moment(modalDate).isSameOrAfter(moment(), 'month')
  const data = useMemo(() => (loggedAt?: string) => {
    if (!lastUpdatePond || !lastUpdateCycle || !lastUpdateCycleToDo) return [];
    const cycles = [];
    pondStoreModels.forEach((pondStore) => {
      const cycleStore = pondStore.getActiveCycleStoreModelByDate(loggedAt)
      if (!cycleStore) return;
      cycles.push({
        ...cycleStore.cycle,
        cycle_to_dos: cycleStore.cycleToDos,
        started_at: cycleStore.cycle.started_at,
        age: cycleStore.cycle.age,
        pond: pondStore.pond,
        get ageAtDate() {
          return (this.initial_age || 0) + moment(loggedAt).startOf('day')
            .diff(moment(this.started_at).startOf('day'), 'days')
        },
        get cycleToDoAtDate() {
          return this.cycle_to_dos.find((c) => c.logged_at === loggedAt)
        },
        get cycle_to_do() {
          return this.cycleToDoAtDate;
        }
      })
    })
    return cycles;
  }, [lastUpdateCycle, lastUpdateCycleToDo, lastUpdatePond, pondStoreModels])

  useEffect(() => {
    const start = moment(modalDate).startOf('month');
    const end = moment(modalDate).endOf('month');
    let dates = [];
    if (farmStore) {
      while (start.isBefore(end)) {
        if(start <= moment()){
          dates.push(start.format('YYYY-MM-DD'));
        }
        start.add(1, 'day');
      }
      dates = dates.map((loggedAt) => {
        return { logged_at: loggedAt, cycles: data(loggedAt) }
      })
      setDateList(dates.reverse())
    }
    setLoading(false)
  }, [data, farmStore, modalDate])

  const previousDate = useCallback(() => {
    setLoading(!loading)
    setModalDate(moment(modalDate).subtract(1, 'month').format('YYYY-MM-DD'));
  }, [loading, modalDate])

  const nextDate = useCallback(() => {
    setLoading(!loading)
    setModalDate(moment(modalDate).add(1, 'month').format('YYYY-MM-DD'));
  }, [loading, modalDate])

  const onCloseModal = useCallback(() => {
    setModalDate(moment(date).format('YYYY-MM-DD'))
    onClose()
  }, [date, onClose])

  const renderItem: ListRenderItem<any> = useCallback((info) => {
    return <DateModalItem info={info} onPress={onPressDateItem(info.item.logged_at)} />
  }, [onPressDateItem])

  const labelColor = disabled ? color.palette.gray600 : color.palette.gray800

  return (
    <Modal
      isVisible={isOpen}
      style={MODAL}
      onBackdropPress={onCloseModal}
      backdropTransitionOutTiming={0}
      backdropColor={color.primary}
      animationIn="slideInUp"
      animationOut="slideOutDown"
      animationInTiming={300}
      animationOutTiming={300}
      backdropTransitionInTiming={600}
    >
    {/* <Modal style={MODAL} isOpen={isOpen} onClose={onClose} animationPreset="slide"> */}
      <SafeAreaView />
      <View style={DATE_MODAL_CONTAINER}>
        <View style={DATE_MODAL_HEADER}>
          <Text tx="shrimpPriceScreen.datePlaceholder" preset="title3" color={color.palette.gray800} />
          <TouchableOpacity onPress={onCloseModal}>
            <Text tx="common.close" preset="title4" color={color.primary} />
          </TouchableOpacity>
        </View>
        <View style={DATE_HEADER}>
          <TouchableOpacity style={ARROW} onPress={previousDate}>
            <JalaIcon name="chevron_left" size={25} color={color.palette.gray800} />
          </TouchableOpacity>
          <Text text={moment(modalDate).format("MMMM YYYY")} color={color.palette.gray800} preset="body2" />
          <TouchableOpacity style={ARROW} onPress={nextDate} disabled={disabled}>
            <JalaIcon name="chevron_right" size={25} color={labelColor} />
          </TouchableOpacity>
        </View>
        <View style={BORDER} />
        {loading ?
          <View flexGrow={1} alignItems="center" justifyContent="center" height="50px" marginTop="20px" marginBottom="20px">
            <JalaLoading />
          </View> :
          <ScrollView marginBottom="40px">
            <FlatList
              data={dateList}
              renderItem={renderItem}
              // estimatedItemSize={209}
            />
          </ScrollView>
        }
      </View>
    </Modal>
  )
})

export const ActivityScreen: FC<{ colorScheme?: "light" | "dark" } & CompositeScreenProps<any, any>> = observer(function ActivityScreen(props) {
  const { colorScheme = "light" || Appearance.getColorScheme(), route: { params } } = props

  const {
    appStore: { farmStore },
    cycleToDoStore, cycleToDoStore: { loading },
    feedStore, feedStore: { needRefresh: feedNeedRefresh, modifying: feedModifying },
    waterQualityMultiMeasurementStore, waterQualityMultiMeasurementStore: { needRefresh: waterQualityMultiMeasurementNeedRefresh, modifying: waterQualityMultiMeasurementModifying },
    treatmentStore, treatmentStore: { needRefresh: treatmentNeedRefresh, modifying: treatmentModifying },
    harvestStore, harvestStore: { needRefresh: harvestNeedRefresh, modifying: harvestModifying },
    samplingStore, samplingStore: { needRefresh: samplingNeedRefresh, modifying: samplingModifying },
    feedingTrayControlStore, feedingTrayControlStore: { needRefresh: feedingTrayControlNeedRefresh, modifying: feedingTrayControlModifying },
    mortalityStore, mortalityStore: { needRefresh: mortalityNeedRefresh, modifying: mortalityModifying }
  } = useStores();

  const {
    pondStoreModels, cycleStoreModels,
    lastUpdatePond, lastUpdateCycle, lastUpdateCycleToDo,
    syncedCycleToDo,
    loadingPond, loadingCycle
  } = farmStore || FarmStoreModel.create({});

  const needRefresh = feedNeedRefresh
    || waterQualityMultiMeasurementNeedRefresh
    || treatmentNeedRefresh
    || harvestNeedRefresh
    || samplingNeedRefresh
    || feedingTrayControlNeedRefresh
    || mortalityNeedRefresh

  const modifying = feedModifying
    || waterQualityMultiMeasurementModifying
    || treatmentModifying
    || harvestModifying
    || samplingModifying
    || feedingTrayControlModifying
    || mortalityModifying

  const clearNeedRefresh = useCallback(() => {
    feedStore.set('needRefresh', false); feedStore.set('pushIdQueue', {});
    waterQualityMultiMeasurementStore.set('needRefresh', false); waterQualityMultiMeasurementStore.set('pushIdQueue', {});
    treatmentStore.set('needRefresh', false); treatmentStore.set('pushIdQueue', {});
    harvestStore.set('needRefresh', false); harvestStore.set('pushIdQueue', {});
    samplingStore.set('needRefresh', false); samplingStore.set('pushIdQueue', {});
    feedingTrayControlStore.set('needRefresh', false); feedingTrayControlStore.set('pushIdQueue', {});
    mortalityStore.set('needRefresh', false); mortalityStore.set('pushIdQueue', {});
  }, [feedStore, feedingTrayControlStore, harvestStore, mortalityStore, samplingStore, treatmentStore, waterQualityMultiMeasurementStore])

  const { height } = useWindowDimensions();

  const [ emptyKey, setEmptyKey ] = useState<string>('farm')
  const [ date, setDate ] = useState<string>(moment().format('YYYY-MM-DD'))
  const [ selectedCycle, setSelectedCycle ] = useState<any>({})
  const [ statusOpen, setStatusOpen ] = useState<boolean>(false)
  const [ dateShow, setDateShow ] = useState<boolean>(false)

  const data = useMemo(() => {
    if (!lastUpdatePond || !lastUpdateCycle || !lastUpdateCycleToDo) return [];
    const cycles = [];
    pondStoreModels.forEach((pondStore) => {
      const cycleStore = pondStore.getActiveCycleStoreModelByDate(date)
      if (!cycleStore) return;
      cycles.push({
        ...cycleStore.cycle,
        cycle_to_dos: cycleStore.cycleToDos,
        started_at: cycleStore.cycle.started_at,
        age: cycleStore.cycle.age,
        pond: pondStore.pond,
        get ageAtDate() {
          return (this.initial_age || 0) + moment(date).startOf('day')
            .diff(moment(this.started_at).startOf('day'), 'days')
        },
        get cycleToDoAtDate() {
          return this.cycle_to_dos.find((c) => c.logged_at === date)
        },
        get cycle_to_do() {
          return this.cycleToDoAtDate;
        }
      })
    })
    return cycles;
  }, [date, lastUpdateCycle, lastUpdateCycleToDo, lastUpdatePond, pondStoreModels])

  const dataFiltered = useMemo(() => data.filter((datum) => (
    (datum?.pond?.name || '').toLowerCase().includes((params?.data?.text || '').toLowerCase())
  )), [data, params?.data?.text])

  useEffect(() => {
    cycleToDoStore.init()
    JalaAnalytic.log('Mobile App: Visit Activity', {
      totalActiveCycles: data.length
    })
  }, [cycleToDoStore, data.length])

  useFocusEffect(useCallback(() => {
    if (!farmStore || !lastUpdateCycle || !lastUpdatePond) return;
    farmStore.getCycleToDos()
  }, [farmStore, lastUpdateCycle, lastUpdatePond]))

  useEffect(() => {
    if (needRefresh) farmStore.getCycleToDos(true, clearNeedRefresh)
  }, [clearNeedRefresh, farmStore, needRefresh])

  useEffect(() => {
    if (!farmStore || !farmStore.farm) setEmptyKey('farm')
    else if (!pondStoreModels.length) setEmptyKey('pond')
    else if (cycleStoreModels.find((cycleStore) => cycleStore.cycle.started_at > date)) setEmptyKey('cycleNoButton')
    else if (data.length && !dataFiltered.length) setEmptyKey('emptySearch')
    else setEmptyKey('cycle')
  }, [cycleStoreModels, cycleStoreModels.length, data.length, dataFiltered.length, date, farmStore, pondStoreModels.length])

  const previousDate = useCallback(() => {
    setDate(moment(date).subtract(1, 'day').format('YYYY-MM-DD'));
  }, [date])

  const nextDate = useCallback(() => {
    setDate(moment(date).add(1, 'day').format('YYYY-MM-DD'));
  }, [date])

  const onNavigateSetting = useCallback(() => {
    const existingState = farmStore.farm.state && farmStore.farm.state.cycle_to_do
    const arrayNew = [
      { key: 'feeding_tray_control', from: 30, to: 90 },
      { key: 'sampling', from: 30, to: 90 },
      { key: 'mortality', from: 30, to: 90 },
      { key: 'harvest_partial', from:30, to: 90 },
      { key: 'harvest_total', from: 30, to: 90 }
    ]
    let existingKey = []
    if( existingState ) {
      existingState.forEach((item) => {
        existingKey = [...existingKey, item.key]
        const index = arrayNew.findIndex(param => param.key === item.key)
        if (index > -1) arrayNew[index] = item
        return arrayNew
      })
    }
    const active = [...new Set(existingKey)]
    navigate('Home.Stack', 'Home.Activity.Setting', {
      activeKeys: active, initialValues: arrayNew
    })
  }, [farmStore])

  const onChangeStatus = useCallback((item) => () => {
    setSelectedCycle(item)
    setStatusOpen(true)
  }, [])

  const onPressModalDate = useCallback((param) => () => {
    if (param.id) setDate(param.logged_at)
    else setDate(param)
    setDateShow(false)
  }, [])

  const renderItem: ListRenderItem<any> = useCallback((info) => {
    return <ActivityItem info={info} colorScheme={colorScheme} onChangeStatus={onChangeStatus(info.item)} selectedDate={date} />
  }, [colorScheme, date, onChangeStatus])

  const keyExtractor = useCallback((item, index) => `${item?.id || index}`, [])

  const isLoading = loading || (farmStore && !syncedCycleToDo) || loadingPond || loadingCycle

  return (<>
    <Screen
      style={ROOT}
      preset="fixed"
      colorScheme={colorScheme}
      backgroundColor={colorScheme === "light" ? color.background : undefined}
      backgroundBar={colorScheme === "light" ? color.primary : undefined}
      statusBar={colorScheme === "light" ? "light-content" : "dark-content"}
      navigationBarBackgroundColor={dataFiltered.length && color.palette.white || color.background}
      hideOnBlurred={false}
      unsafe
    >
      <Header />
      <DateHeader date={date} onPrevious={previousDate} onNext={nextDate} onPressDate={() => setDateShow(true)} disabled={isLoading} />
      <FlatList
        data={dataFiltered}
        renderItem={renderItem}
        keyExtractor={keyExtractor}
        ListEmptyComponent={isLoading ? (
          <View flexGrow={1} alignItems="center" justifyContent="center" height={`${height - 214}px`}>
            <JalaLoading />
          </View>
        ) : <EmptyState screen={emptyKey} height={`${height - 214}px`} />}
        ListFooterComponent={<SafeAreaView edges={['bottom']} />}
        showsVerticalScrollIndicator={false}
        estimatedItemSize={235}
        refreshControl={<RefreshControl
          refreshing={cycleToDoStore.refreshing}
          onRefresh={cycleToDoStore.onRefresh}
        />}
      />
      {!!data.length && <View style={BOTTOM_BUTTON_CONTAINER}>
        <View paddingBottom="10px">
          <TouchableOpacity testID="jala:id/activity-setting-button" onPress={onNavigateSetting}>
            <View style={BOTTOM_BUTTON}>
              <AutoImage source={setting} style={SETTING_IMAGE} />
              <Text tx="cycleToDoScreen.setting" preset="title3" color={color.palette.white} />
            </View>
          </TouchableOpacity>
        </View>
        <SafeAreaView edges={['bottom']} />
      </View>}
      <ModalChangeStatus isOpen={statusOpen} onClose={() => setStatusOpen(!statusOpen)} cycle={selectedCycle} date={date} />
      <ModalDate date={date} isOpen={dateShow} onClose={() => setDateShow(!dateShow)} onPressDateItem={onPressModalDate} key={date} />
      <ModalJalaLoading isOpen={needRefresh || modifying} />
    </Screen>
    <OfflineMode colorScheme={colorScheme} onFinishPushAll={farmStore?.getCycleToDos} marginBottom="72px" />
  </>)
})
